import { useEffect, useState } from 'react'
import kycCore from '../services/Kyc'

const useGetCertificateHook = () => {
  const { certificate } = kycCore
  const [fileUrl, setFileUrl] = useState<string>('')
  const getPdf = async () => {
    const response = await certificate.getCompletedCertificate({
      documentType: '9',
    })
    const file =
      response.status === 200
        ? await response.blob()
        : new Blob(['Document Error'])
    setFileUrl(URL.createObjectURL(file))
  }
  useEffect(() => {
    if (!fileUrl) {
      getPdf()
    }
    // eslint-disable-next-line
  }, [fileUrl])
  return { fileUrl }
}

export default useGetCertificateHook
